import { createSlice } from "@reduxjs/toolkit";
import {
  IMerchantResponse,
  IStoreResponse,
} from "../../typings/interfaces/responses/all-merchants-response";
import { updateMerchantTaxConfig } from "../actions/merchantAction";

export interface MasterState {
  adminDashboardSelectedStore: IStoreResponse | null;
  adminDashboardSelectedMerchant: IMerchantResponse | null;
  storeSelectorDrawerOpen: boolean;
}

const initialState: MasterState = {
  adminDashboardSelectedStore: null,
  adminDashboardSelectedMerchant: null,
  storeSelectorDrawerOpen: false,
};

const masterSlice = createSlice({
  name: "master",
  initialState,
  reducers: {
    setAdminDashboardSelectedStore: (state, action) => {
      state.adminDashboardSelectedStore = action.payload;
    },
    setAdminDashboardSelectedMerchant: (state, action) => {
      state.adminDashboardSelectedMerchant = action.payload;
    },
    setStoreSelectorDrawerOpen: (state, action) => {
      state.storeSelectorDrawerOpen = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(updateMerchantTaxConfig.fulfilled, (state, action) => {
      const { merchantId, taxEnabled } = action.meta.arg;
      if (state.adminDashboardSelectedMerchant?.merchantId === merchantId) {
        state.adminDashboardSelectedMerchant.taxEnabled = taxEnabled;
      }
    });
  },
});

export default masterSlice.reducer;
export const MasterSliceActions = masterSlice.actions;
